import { useSelector } from '/druid/internal/WebChatReduxContext';
import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useDictateInterims(): [string[], (interims: string[]) => void] {
  return [useSelector(({ dictateInterims }) => dictateInterims) || [], useWebChatAPIContext().setDictateInterims];
}
